// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"890123b6","362":"b6f1f082","384":"c186e022","924":"b5747365"}[chunkId] + ".chunk.css";
};